import React from 'react'

export const ListProductPlaceholder = () => {
  return (
    <>
      {[...Array(24)].map((_, i) => (
        <div key={i} className='cardPlaceholder animate-pulse flex flex-column gap-half my1'>
          <picture className='' style={{ height: '258px', backgroundColor: 'lightgray' }} />
          <div className='' style={{ height: '25px', backgroundColor: 'lightgray' }} />
          <div className='' style={{ height: '25px', backgroundColor: 'lightgray' }} />
        </div>
      ))}
    </>
  )
}
